import { render, staticRenderFns } from "./terms-input.vue?vue&type=template&id=52b5d8f0&"
import script from "./terms-input.vue?vue&type=script&lang=js&"
export * from "./terms-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports